// ============================================
// GateLoader — token-switch loading state
//
// Terminal-grade: a hairline cheese wedge (brand, reduced to line art),
// a letterspaced mono status, and a blinking block cursor. Sits at the
// bottom-left of the CHART — absolute against the token-switch overlay
// (an absolute, full-chart-area div in FootprintChartCanvas).
//
// Usage:
//   <GateLoader />
//   <GateLoader label="connecting" />
// ============================================

export default function GateLoader({ label = 'loading orderflow' }) {
  return (
    <div className="gate-loader">
      <style>{`
        .gate-loader {
          position: absolute;
          left: 18px;
          bottom: 18px;
          display: flex;
          align-items: center;
          gap: 10px;
          z-index: 10;
          font-family: 'JetBrains Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #8a8f9c;
          user-select: none;
        }
        .gate-loader .gl-cursor {
          display: inline-block;
          width: 7px;
          height: 13px;
          margin-left: 2px;
          background: var(--accent, #ffb020);
          animation: gl-blink 1.1s steps(1) infinite;
        }
        @keyframes gl-blink {
          0%, 49%  { opacity: 1; }
          50%, 100% { opacity: 0; }
        }
        @media (prefers-reduced-motion: reduce) {
          .gate-loader .gl-cursor { animation: none; opacity: 0.7; }
        }
      `}</style>
      {/* The wedge — brand mark as instrument line art */}
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="#8a8f9c" strokeWidth="1.3" strokeLinejoin="round" aria-hidden="true">
        <path d="M2.5 17.5 L21.5 17.5 L21.5 10.5 L2.5 17.5 Z" />
        <circle cx="16.5" cy="14.8" r="1.2" />
        <circle cx="10.5" cy="16" r="0.8" />
      </svg>
      <span aria-label="Loading">{label}</span>
      <span className="gl-cursor" />
    </div>
  )
}